import { useEffect, useState } from 'react';
import { PageSkeleton } from '@/components/ui/skeletons';
import { Button } from '@/components/ui/button';
import { RefreshCw, WifiOff } from 'lucide-react';

/**
 * Écran d'attente des routes chargées à la demande, avec une issue.
 *
 * POURQUOI : le fallback de Suspense affichait un squelette indéfiniment. Quand
 * l'import du module ne se termine JAMAIS — réseau qui ne répond pas, ou fragment de
 * code disparu après un redéploiement pendant que l'onglet était ouvert — la promesse
 * ne rejette pas, donc ni l'ErrorBoundary ni installChunkErrorListener ne se
 * déclenchent. Rien ne rattrapait ce cas : l'utilisateur restait devant un squelette
 * sans savoir quoi faire.
 *
 * Le rechargement automatique existant est par ailleurs limité à UNE fois par session
 * (garde-fou anti-boucle), donc une seconde panne dans la même session n'était pas
 * rattrapée non plus.
 *
 * Après quelques secondes, on nomme le problème et on rend la main.
 */

const DELAI_AVERTISSEMENT_MS = 8000;

export const PageLoaderWithEscape = () => {
  const [tropLong, setTropLong] = useState(false);

  useEffect(() => {
    const minuteur = window.setTimeout(() => setTropLong(true), DELAI_AVERTISSEMENT_MS);
    return () => window.clearTimeout(minuteur);
  }, []);

  if (!tropLong) return <PageSkeleton />;

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <WifiOff className="h-8 w-8 text-muted-foreground" aria-hidden="true" />
      <div className="space-y-1">
        <p className="font-medium">Le chargement prend plus de temps que prévu.</p>
        <p className="text-sm text-muted-foreground">
          Cela arrive après une mise à jour du site : votre navigateur cherche une version
          du code qui n'existe plus. Recharger la page suffit à le corriger.
        </p>
      </div>
      <Button onClick={() => window.location.reload()} className="gap-2">
        <RefreshCw className="h-4 w-4" />
        Recharger la page
      </Button>
    </div>
  );
};
